import { Component, OnInit, isDevMode } from '@angular/core';
import {
	NavigationCancel,
	NavigationEnd,
	NavigationError,
	Router,
} from '@angular/router';
import { MonitoringService } from './services/monitoring/monitoring.service';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';
import { selectProductInfo } from 'src/app/state/selectors/pre-application.selectors';
import { OnboardingProcessFlowService } from './services/onboarding-process-flow.service';
import { NavigationSyncService } from './services/navigation-sync.service';
@Component({
	selector: 'cmv-app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
	title = 'onBoardingDigital';
	isDevMode: boolean;

	constructor(
		private router: Router,
		private monitoringService: MonitoringService,
		private store: Store,
		private onboardingProcessFlowService: OnboardingProcessFlowService,
		private navigationSyncService: NavigationSyncService
	) {
		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				this.addMonitoringViewNameWithProductInfo(event);
			}
			// Una navegación cancelada (p. ej. por CorrectNavigationGuard) o con
			// error no emite NavigationEnd; si solo se escuchara ese evento, el
			// candado de cambio de paso se quedaría prendido para siempre.
			if (
				event instanceof NavigationEnd ||
				event instanceof NavigationCancel ||
				event instanceof NavigationError
			) {
				this.markChangingStepAsCompleted();
			}
		});
		this.navigationSyncService.init();
	}

	private markChangingStepAsCompleted() {
		if (this.onboardingProcessFlowService.isChangingStep) {
			this.onboardingProcessFlowService.changingStepCompleted();
		}
	}

	private addMonitoringViewNameWithProductInfo(event: NavigationEnd) {
		this.store
			.select(selectProductInfo)
			.pipe(take(1))
			.subscribe(productInfo => {
				this.monitoringService.addViewName(event.url, productInfo.productName);
			});
	}

	ngOnInit(): void {
		this.isDevMode = isDevMode();
	}
}
